import { postLikeFolder } from './postLikeFolder';
import { getLikedFolders } from './getLikedFolders';

export const likedFolderService = {
  get: getLikedFolders,
  post: postLikeFolder,
};
